const siteUrlFromEnv = import.meta.env.VITE_SITE_URL as string | undefined;

export const SITE_URL = (typeof siteUrlFromEnv === "string" && siteUrlFromEnv.length > 0
  ? siteUrlFromEnv
  : "https://basetaosheet.boats"
).replace(/\/+$/, "");

export const SITE_NAME = "Basetao Sheet";

export const SITE_TITLE = "Basetao Spreadsheet: Products, Reviews & Shipping Guide";

export const SITE_DESCRIPTION =
  "Independent resource hub for Basetao Spreadsheet — find products, compare sellers, check QC photos, shipping costs and whether Basetao is legit.";

export const DATE_PUBLISHED = "2026-08-19";

export const AUTHOR_NAME = "Basetao Sheet Editorial Team";